import {
  type MonthlyTourReportDailyReportListExEntity,
  apiClient
} from '@/libs/api'
import { type MonthlyTourReportDailyReportsRequestQuery } from '@/libs/api/types'

export type FetchMonthlyTourReportDailyReportsQuery = {
  tenantKey: string
  monthlyTourReportId: number
  query: MonthlyTourReportDailyReportsRequestQuery
}

export const fetchMonthlyTourReportDailyReports = async (
  {
    tenantKey,
    monthlyTourReportId,
    query
  }: FetchMonthlyTourReportDailyReportsQuery,
  signal?: AbortSignal
): Promise<MonthlyTourReportDailyReportListExEntity[]> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .monthly_tour_reports._reportId(monthlyTourReportId)
    .daily_reports.$get({ query, config: { signal } })
  return data
}
